import { Box, Grid, Radio, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Accordian, TextField } from '../../components';
import VehicleCompare from '../VehicleCompare';
import { ISearchCustomer } from '../../types/inventory';
import { ICompSummaryBase } from '../../types';

interface Props {
  vehicle: ISearchCustomer;
  toCompareVehicle: ICompSummaryBase & { [key: string]: string };
  onSelect: (selection: ISearchCustomer | null) => void;
  selected: ISearchCustomer | null;
}

const SearchResults: React.FC<Props> = ({ vehicle, toCompareVehicle, onSelect, selected }) => {
  const [expanded, setExpanded] = useState(false);
  const { customerVehicle } = vehicle;

  const isCurrentSelected = () => selected?.customerVehicle._id === vehicle.customerVehicle._id;

  const header = (
    <Grid container spacing={1} minHeight={75}>
      <Grid xs={0.3} mt={1}>
        <Radio
          onChange={() => onSelect(vehicle)}
          checked={isCurrentSelected()}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: 18,
            },
          }}
        />
      </Grid>
      <Grid xs={2} alignSelf="center">
        <Typography variant="body2">{customerVehicle.customerName}</Typography>
        <Typography variant="caption" color={(theme) => theme.palette.grey[800]}>
          {customerVehicle.phone || 'N/A'} | {customerVehicle.email || 'N/A'}
        </Typography>
      </Grid>

      {customerVehicle.vehicleStage === 'Reserved' && (
        <Grid xs={2.5} alignSelf="center">
          <Typography variant="body2" color={(theme) => theme.palette.grey[800]}>
            Reservation ID
          </Typography>
          <Typography variant="caption">{customerVehicle.reservationNumber}</Typography>
        </Grid>
      )}

      {customerVehicle.vehicleStage !== 'Reserved' && (
        <Grid xs={1.5} alignSelf="center">
          <Typography variant="body2" color={(theme) => theme.palette.grey[800]}>
            Order Number
          </Typography>
          <Box mt={2.6}>
            <Typography variant="caption" fontWeight="Bold">
              {customerVehicle.orderNumber}
            </Typography>
          </Box>
        </Grid>
      )}

      {customerVehicle.vehicleStage !== 'Reserved' && (
        <Grid xs={3} alignSelf="center" paddingRight="10px">
          <Typography variant="body2" color={(theme) => theme.palette.grey[800]}>
            Ordered Vehicle
          </Typography>
          <Box mt={0.2}>
            <Typography variant="caption" fontSize="0.8rem" fontWeight="Bold">
              {customerVehicle.year}, {customerVehicle.model}, {customerVehicle.exteriorColor},{' '}
              {customerVehicle.interiorColor}, {customerVehicle.roof}, {customerVehicle.wheels}
            </Typography>
            {customerVehicle.currentState && customerVehicle.currentCity && (
              <Typography variant="caption" fontSize="0.8rem" fontWeight="Bold">
                {'\n'}Currently in {customerVehicle.currentCity}, {customerVehicle.currentState}
              </Typography>
            )}
          </Box>
        </Grid>
      )}

      <Grid xs={1.5} alignSelf="center">
        <Box>
          <Typography variant="body2" color={(theme) => theme.palette.grey[800]}>
            Vehicle Stage
          </Typography>
        </Box>
        <Box mt={2.6}>
          <Typography variant="caption" fontWeight="Bold">
            {customerVehicle.vehicleStage}
          </Typography>
        </Box>
      </Grid>
      <Grid xs={2} alignSelf="center">
        <Typography variant="body2" color={(theme) => theme.palette.grey[800]}>
          Customer Stage
        </Typography>
        <Box mt={2.6}>
          <Typography variant="caption" fontWeight="Bold">
            {customerVehicle.customerStage}
          </Typography>
        </Box>
      </Grid>
      {customerVehicle.vehicleStage !== 'Reserved' && (
        <Grid xs={1.5} alignSelf="center">
          <Typography variant="body2" color={(theme) => theme.palette.grey[800]}>
            VIN Assigned
          </Typography>
          <Box mt={2.7}>
            <Typography variant="caption" fontWeight="Bold">
              {customerVehicle.vin}
            </Typography>
          </Box>
        </Grid>
      )}
    </Grid>
  );

  return (
    <Accordian
      sx={{ width: '100%' }}
      header={header}
      styleVariant="secondary"
      expanded={expanded}
      onChange={() => {
        setExpanded((prev) => !prev);
        onSelect(vehicle);
      }}
    >
      <VehicleCompare customerVehicle={vehicle.customerVehicle} inventoryVehicle={toCompareVehicle} />
    </Accordian>
  );
};

export default SearchResults;
